import { useStaticQuery, graphql } from "gatsby"

export const useBranchData = () => {
  const wordpress = useStaticQuery(graphql`query getBranches {
    allWpBranch {
      edges {
        node {
          id
          title
          Branch {
            contacts {
              email
              name
              title
            }
            specReps {
              email
              name
              phone
            }
            generalEmail
            phoneNumber
            faxNumber
            branchAddress {
              city
              streetAddress
              streetName
              streetNumber
              postCode
              stateShort
            }
            branchImage {
              sourceUrl
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
              }
            }
            branchFeaturedVendors {
              ... on WpVendor {
                id
                title
                VendorInfo {
                  externalUrl
                  logo {
                    altText
                    uri
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(layout: FULL_WIDTH)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
}
`)

   return wordpress.allWpBranch.edges
}
